import { createSlice } from "@reduxjs/toolkit";

const priceRangeSlice = createSlice({
  name: "priceRange",
  initialState: {
    minPrice: 0,
    maxPrice: 20000, // Default value until API response is received
  },
  reducers: {
    setPriceRange(state, action) {
      state.minPrice = action.payload.min_price;
      state.maxPrice = action.payload.max_price;
    },
  },
});

export const { setPriceRange } = priceRangeSlice.actions;
export default priceRangeSlice.reducer;